module.exports = __webpack_public_path__ + "img/OverseaMember13.6baf439c.jpg";